var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useCallback } from 'react';
import { Box, Button, List } from '@mui/material';
import ListItem from './ListItem';
var SelectableList = function (props) {
    var values = props.values, onItemSelected = props.onItemSelected, initialSelectedItems = props.initialSelectedItems;
    var _a = useState(initialSelectedItems || []), selectedItems = _a[0], setSelectedItems = _a[1];
    var handleClick = useCallback(function (value) {
        setSelectedItems(function (prevSelectedItems) {
            var newSelectedItems = [];
            if (prevSelectedItems.indexOf(value.value) > -1) {
                newSelectedItems = prevSelectedItems.filter(function (item) {
                    return item !== value.value;
                });
            }
            else {
                newSelectedItems = __spreadArray([value.value], prevSelectedItems, true);
            }
            onItemSelected(newSelectedItems);
            return newSelectedItems;
        });
    }, []);
    var handleSelectAllClick = function () {
        setSelectedItems(function () {
            var newSelectedItems = values.map(function (value) {
                return value.value;
            });
            onItemSelected(newSelectedItems);
            return newSelectedItems;
        });
    };
    var handleUnSelectAllClick = function () {
        setSelectedItems(function () {
            onItemSelected([]);
            return [];
        });
    };
    return (React.createElement(Box, null,
        React.createElement(Button, { autoFocus: false, disableFocusRipple: true, disableRipple: true, disabled: selectedItems.length === values.length, onClick: handleSelectAllClick }, "Select all"),
        React.createElement(Button, { autoFocus: false, disableFocusRipple: true, disableRipple: true, disabled: selectedItems.length === 0, onClick: handleUnSelectAllClick }, "Unselect all"),
        React.createElement(List, null, values.map(function (value) {
            return (React.createElement(ListItem, { onClick: handleClick, checked: selectedItems.indexOf(value.value) > -1, value: value, key: "top-list-".concat(value.value) }));
        }))));
};
export default SelectableList;
